module.exports = __webpack_public_path__ + "img/5.5864f8f1.png";